<div class="closeButton"  (mouseenter)="onCloseOver()" (mouseleave)="onCloseOut()" #btnClose>
    <div class="closeLine"></div>
    <img [src]="closeButtonImg" alt="" class="closeImg">
</div>	